import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from '../shared.module';
import { NavbarComponent } from '../../layouts/navbar/navbar.component';
import { Footer2Component } from '../../layouts/footer2/footer2.component';
import { RestaurantleftsidebarComponent } from '../../layouts/restaurantleftsidebar/restaurantleftsidebar.component';
import { RestaurantrightsidebarComponent } from '../../layouts/restaurantrightsidebar/restaurantrightsidebar.component';
import { BookingCustomSidebarComponent } from '../../layouts/booking-custom-sidebar/booking-custom-sidebar.component';

@NgModule({
  declarations: [
    NavbarComponent,
    Footer2Component,
    RestaurantleftsidebarComponent,
    RestaurantrightsidebarComponent,
    BookingCustomSidebarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule,
    EffectsModule,
    SharedModule,
  ],
  exports: [
    NavbarComponent,
    Footer2Component,
    RestaurantleftsidebarComponent,
    RestaurantrightsidebarComponent,
    BookingCustomSidebarComponent,
  ],
})
export class LayoutsModule {}

